import axiosPrivate from "../axiosPrivate"

export const dumbDuplicateAdset = async (adSetId, targetCampaignId = null) => {
    let endpoint = `${adSetId}/copies`
    if (targetCampaignId) {
        endpoint += `?campaign_id=${targetCampaignId}`
    }
    return await axiosPrivate.post(endpoint)
    // return await axiosPrivate.post(`${adSetId}/copies?campaign_id=${targetCampaignId}`)
}

export const getAdsetDetails = async (adSetId) => {
    let endpoint = `${adSetId}`
    let feilds = "id,name,targeting,status"
    endpoint += `?fields=${feilds}`
    return await axiosPrivate.get(endpoint)
}

export const updateAdset = async (adSetId, data) => {
    return await axiosPrivate.post(`${adSetId}`, data)
}
